import {Component, OnInit, Input, Output, OnDestroy} from '@angular/core';
import { EventEmitter } from '@angular/common/src/facade/async';
import { EnumStatusTrip, IStatusChange, STATUSTRIP } from '../../../core/interfaces/change-status.interface';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-btn-status',
  templateUrl: './btn-status.component.html',
  styleUrls: ['./btn-status.component.scss']
})
export class BtnStatusComponent implements OnInit, OnDestroy {


  /**
   * StatusIn (@Input) parametro que recibe el status actual de la reserva
   * StatusOut (@Output) parametro que genera el status de salida.
   */
  @Input() statusIn: any;
  @Input() companyId: number;
  @Input() isCompanyOndemand = false;
  @Input() showActive = true;
  @Output() statusOut: EventEmitter < number > = new EventEmitter < number > ();
  @Input() onlyForCancel = false;
  public enumStatus = EnumStatusTrip;
  public statusTrip = STATUSTRIP;
  public statusSelect: IStatusChange[] = [];
  public form: FormGroup;
  private actVerify = false;
  private actBilled = false;
  private subscriptions: Subscription = new Subscription();
  constructor(
    private fb: FormBuilder,
  ) {
    this.createForm();
  }

  /**
   * @name ngOnInit
   * @description
   */
  ngOnInit() {
    this.loadStatus(this.statusIn);

    if (this.onlyForCancel) {
      this.clicBtn(7);
    }
  }

  /**
   * @name createForm
   * @description crea formulario
   */
  private createForm(): void {
    this.form = this.fb.group({
      statusChange: [null, [Validators.required]],
    });
    this.subscriptions.add(this.form.get('statusChange').valueChanges.subscribe(
      (id: number) => {
        this.clicBtn(id);
      }
    ));
  }

  /**
   * @description carga los estatus a utilizar
   * @param ids los id de los status a utilizar
   */
  chargeStatus(ids: number[]): void {
    const data: IStatusChange[] = [];
    ids.forEach((id: number) => {
        const status = this.statusTrip.find(f => f.id === id);
        if (status) { data.push(status); }
    });
    this.statusSelect = data;
  }

  public loadStatus(status: number) {
    switch (status) {
      case this.enumStatus.Open:
      {
        this.chargeStatus([this.enumStatus.Active, this.enumStatus.Cancelled]);
        if (this.companyId === 25) {
          this.chargeStatus([this.enumStatus.Accepted, this.enumStatus.Cancelled]);
        }
        if (this.companyId === 19) {
          // Todo verificar si se debe mostrar Accepted
          /*this.statusSelect.push(this.chargeStatus([this.enumStatus.Accepted])[0]);*/
        };
      }
      break;
      case this.enumStatus.Active:
      {}
      break;
      case this.enumStatus.Hold:
      {
        this.chargeStatus([this.enumStatus.Open, this.enumStatus.Cancelled]);
      }
      break;
      case this.enumStatus.Accepted:
      {
        this.chargeStatus([this.enumStatus.Pickup, this.enumStatus.Cancelled]);
      }
      break;
      case this.enumStatus.Pickup:
        // this.actCompleted = true;
        // this.actNoShow = true;
        // this.actCancelled = true;
        // if (this.companyId === 19) {
        //   this.actAccepted = true;
        //   this.btnAccepted = 'Accepted';
        // }
        break;
      case this.enumStatus.NoShow:
      {
        this.chargeStatus([this.enumStatus.Active, this.enumStatus.Active]);
      }
      break;
      case 7:
      break;
      case this.enumStatus.Rejected:
      {
        this.chargeStatus([this.enumStatus.Active]);
      }
      break;
      case this.enumStatus.Completed:
        this.actVerify = true;
        this.actBilled = true;
        break;
      case this.enumStatus.Verify:
        this.actBilled = true;
        break;
      case this.enumStatus.Billed:
      {
        this.chargeStatus([this.enumStatus.Closed]);
      }
      break;
      case this.enumStatus.Scheduled:
      {
        this.chargeStatus([this.enumStatus.Pickup, this.enumStatus.Accepted]);
      }
      break;
      case this.enumStatus.Arrived:
      {
        this.chargeStatus([this.enumStatus.Pickup]);
      }
      break;
    }
    if (!this.showActive) {
      this.chargeStatus([this.enumStatus.Cancelled]);
    }
  }

  private clicBtn(status: number) {
    if (this.isCompanyOndemand && status === 2) {
      status = 14; // 2
    }

    this.statusOut.emit(status);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/btn-status/btn-status.component.ts